export function monthDiff(d1: Date, d2: null): null;
export function monthDiff(d1: null, d2: Date): null;
export function monthDiff(d1: null, d2: null): null;
export function monthDiff(d1: Date, d2: Date): number;
export function monthDiff(d1: Date | null, d2: Date | null) {
    if (!d1 || !d2) {
        return null;
    }
    let months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months += d2.getMonth() - d1.getMonth();

    if (d2.getDate() < d1.getDate()) {
        months--;
    }

    return months <= 0 ? null : months;
}
